import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {SettingsComponent} from './settings.component';
import {SettingsListComponent} from './settings-list/settings-list.component';
import {SettingsRoutesEnum} from './services/navigation/settings-routes.enum';

const routes: Routes = [
  {
    path: RoutesEnum.SETTINGS,
    component: SettingsComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: SettingsRoutesEnum.LIST,
        component: SettingsListComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class SettingsRoutingModule {
}
